import { render, staticRenderFns } from "./WorkerProfile.vue?vue&type=template&id=4b116530&"
import script from "./WorkerProfile.vue?vue&type=script&lang=js&"
export * from "./WorkerProfile.vue?vue&type=script&lang=js&"
import style0 from "./WorkerProfile.vue?vue&type=style&index=0&id=4b116530&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports